import { useRef, useState } from 'react';
import
{ Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import commonStyles from '../../../../styles';
import RegisterCustomerCardCalendarSp from './registerCustomerCardCalendarSp';
import RegisterCustomerCardFileSp from './registerCustomerCardFileSp';

const useStyles = makeStyles({
  dialog: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'none',
    },
  },
  container: {
    height: '100vh',
    overflowY: 'hidden',
  },
  header: {
    padding: '24px 24px 8px',
  },
  paperTtl: {
    textAlign: 'center',
  },
  content: {
    backgroundColor: '#F3F3F3',
    padding: '16px 0',
    height: '100%',
  },
});

function RegisterCustomerCardSp(props) {
  const {
    open,
    setOpen,
    onClose,
    customerId,
    postCustomerCards,
    getCustomerCards,
    registrationDate,
  } = props;

  const classes = useStyles();
  const baseClasses = commonStyles();

  // アップロードする画像ファイル
  const [fileData, setFileData] = useState();

  // 連打防止
  const processing = useRef(false);

  const dataList = [
    {
      type: 'calendar',
      key: 'date',
      label: '登録日時',
      state: registrationDate,
    },
    {
      type: 'attachment',
      key: 'file',
      label: 'ファイル',
      state: fileData,
      setState: (e) => { return setFileData(e); },
    },
  ];

  const switchType = (val) => {
    const returnType = [];

    switch (val.type) {
      case 'calendar':
        return <RegisterCustomerCardCalendarSp values={val} />;
      case 'attachment':
        return (
          <RegisterCustomerCardFileSp
            fileData={val.state}
            onChange={val.setState}
          />
        );
      default:
        break;
    }
    return returnType;
  };

  const onSubmit = async () => {
    if (processing.current) return;
    processing.current = true;
    setOpen(false);
    await postCustomerCards({
      customerId,
      fileData,
      registrationDate,
    });
    setFileData({});
    // リロードして最新の情報を取得
    getCustomerCards();
    processing.current = false;
  };

  const body = (
    <Grid className={classes.container}>
      <DialogTitle
        id="draggable-dialog-title"
        className={`${baseClasses.header}`}
      >
        <Typography className={`${baseClasses.title2} ${classes.paperTtl}`}>
          顧客カード登録
        </Typography>
        <Button
          className={baseClasses.closeButton}
          onClick={onClose}
        />
      </DialogTitle>
      <DialogContent className={classes.content}>
        {dataList.map((item) => (
          <Grid key={item.key}>
            {switchType(item)}
          </Grid>
        ))}
      </DialogContent>
      <Grid container justifyContent="center" className={`${baseClasses.fixedFooter} ${classes.buttons}`}>
        <Button
          className={`${baseClasses.buttonsPrimary}`}
          onClick={onSubmit}
          disabled={!fileData?.fileName || fileData.fileName.startsWith('.') || fileData.fileName.length > 400}
        >
          登録
        </Button>
      </Grid>
    </Grid>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={`${baseClasses.maxWidthDialog} ${baseClasses.cancelIndex} ${classes.dialog}`}
    >
      {body}
    </Dialog>
  );
}

export default RegisterCustomerCardSp;
